const defaultColorObjects = [
  { label: 'ブラック', value: 'black', color: '#1E1E1E' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'ブルー', value: 'blue', color: '#193B85' },
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: 'コルク', value: 'kurk', color: '#CE7220' },
  { label: 'レッドオレンジ', value: 'redOrange', color: '#ff362e' },
  { label: 'レッド', value: 'red', color: '#CB1527' },
  { label: 'レモンイエロー', value: 'lemonYellow', color: '#D9D943' },
  { label: 'チョコレート', value: 'chocolate', color: '#652821' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'キャメル', value: 'camel', color: '#D7CEA5' }
]

const leatherOfGoldLineObjs = defaultColorObjects

const leatherOfBestSelectObjs = [
  { label: 'BSブラック', value: 'bsBlack', color: '#1E1E1E' },
  { label: 'BSオレンジ', value: 'bsOrange', color: '#FF6C23' },
  { label: 'BSコルク', value: 'bsKurk', color: '#CE7220' },
  { label: 'BSレッドオレンジ', value: 'bsRedOrange', color: '#ff362e' },
  { label: 'BSチョコレート', value: 'bsChocolate', color: '#652821' },
  { label: 'BSキャメル', value: 'bsCamel', color: '#D7CEA5' }
]
const leatherOfJuniorLineObjs = [
  { label: 'JRブラック', value: 'jrBlack', color: '#1E1E1E' },
  { label: 'JRオレンジ', value: 'jrOrange', color: '#FF6C23' },
  { label: 'JRレッドオレンジ', value: 'jrRedOrange', color: '#ff362e' },
  { label: 'JRレモンイエロー', value: 'jrLemonYellow', color: '#D9D943' },
  { label: 'JRチョコレート', value: 'jrChocolate', color: '#652821' },
  { label: 'JRキャメル', value: 'jrCamel', color: '#D7CEA5' },
  { label: 'JRコルク', value: 'jrKurk', color: '#CE7220' }
]

export const laceObjs = [
  { label: 'ホワイト', value: 'white', color: '#fff' },
  { label: '中白ブラック', value: 'materialBlack', color: '#282925' },
  { label: 'ブラック', value: 'black', color: '#282925' },
  { label: 'レッドオレンジ', value: 'redOrange', color: '#CD5442' },
  { label: 'オレンジ', value: 'orange', color: '#FF6C23' },
  { label: 'レモンイエロー', value: 'lemonYellow', color: '#D9D943' },
  { label: 'コルク', value: 'kurk', color: '#CE7220' },
  { label: 'チョコレート', value: 'chocolate', color: '#652821' },
  { label: 'レッド', value: 'red', color: '#CB1527' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'ブルー', value: 'blue', color: '#193B85' },
  { label: 'キャメル', value: 'camel', color: '#D7CEA5' }
]

export const edgeColors = defaultColorObjects

export const stitchObjs = [
  { label: 'ブラック', value: 'black', color: '#0a0a0a' },
  { label: 'オレンジ', value: 'orange', color: '#e37d00' },
  { label: 'ブルー', value: 'blue', color: '#002bff' },
  { label: 'ホワイト', value: 'white', color: '#eee' },
  { label: 'レッド', value: 'red', color: '#c70000' },
  { label: 'イエロー', value: 'yellow', color: '#debd00' },
  { label: 'コルク', value: 'kurk', color: '#CE7220' },
  { label: 'チョコレート', value: 'chocolate', color: '#652821' },
  { label: 'ネイビー', value: 'navy', color: '#363C53' },
  { label: 'パープル', value: 'purple', color: '#6a1ca3' },
  { label: 'ピンク', value: 'pink', color: '#ff1493' },
  { label: 'スカイブルー', value: 'skyBlue', color: '#4EB5DC' },
  { label: 'グリーン', value: 'green', color: '#009c09' },
  { label: 'エンジ', value: 'enji', color: '#9F3433' },
  { label: 'グレー', value: 'gray', color: '#909190' },
  { label: 'キャメル', value: 'camel', color: '#D7CEA5' },
  { label: 'Pピンク', value: 'pPink', color: '#ff91cd' },
  { label: 'Pスカイブルー', value: 'pSkyBlue', color: '#8ce0ff' }
]

export const hamidashiObjs = [
  { label: '切りハミ(ホワイト)', value: 'kirihamiWhite', color: '#fff' },
  { label: '玉ハミ(ブラック)', value: 'black', color: '#1E1E1E' },
  { label: '玉ハミ(オレンジ)', value: 'orange', color: '#FF6C23' },
  { label: '玉ハミ(ブルー)', value: 'blue', color: '#193B85' },
  { label: '玉ハミ(ホワイト)', value: 'white', color: '#fff' },
  { label: '玉ハミ(レッド)', value: 'red', color: '#CB1527' },
  { label: '玉ハミ(レモンイエロー)', value: 'lemonYellow', color: '#D9D943' },
  { label: '玉ハミ(コルク)', value: 'kurk', color: '#CE7220' },
  { label: '玉ハミ(チョコレート)', value: 'chocolate', color: '#652821' },
  { label: '玉ハミ(ネイビー)', value: 'navy', color: '#363C53' },
  { label: '玉ハミ(キャメル)', value: 'camel', color: '#D7CEA5' }
]

export const commonPartsObjs = [
  // 共通
  { label: '全体', value: 'all', order: 0 },
  { label: '捕球面', value: 'catchFace', order: 1 },
  { label: 'ウェブ', value: 'web', order: 2 },
  { label: 'ヘリ革', value: 'edge', order: 4 },
  { label: '親指掛け紐', value: 'thumbHook', order: 5 },
  { label: '小指掛け紐', value: 'littleHook', order: 6 },
  { label: '指当て/指カバー', value: 'indexCover', order: 7 },
  { label: '裏革', value: 'linings', order: 8 }
]

const backInfieldObjs = [
  { label: '親指1', value: 'thumbOut', order: 9 },
  { label: '親指2', value: 'thumbWeb', order: 10 },
  { label: '小指9', value: 'littleRing', order: 11 },
  { label: '小指10', value: 'littleOut', order: 12 },
  { label: 'バンド', value: 'listBelt', order: 13 }
]

export const catchFacePartsObjs = commonPartsObjs
export const web2Objs = { label: 'ウェブ2', value: 'web2', order: 3 }

export const infieldBackPartsObjs = [...commonPartsObjs, ...backInfieldObjs]

// export const partsObjs = [...catchFacePartsObjs, ...backInfieldPartsObjs]

export const ysrLabelObjs = [
  { label: 'YR-1 ゴールドxゴールド', value: 'yr1', imageUrl: '/yellstory/labels/yr1.jpg' },
  { label: 'YR-2 ゴールドxブルー', value: 'yr2', imageUrl: '/yellstory/labels/yr2.jpg' },
  { label: 'YR-3 ゴールドxホワイト', value: 'yr3', imageUrl: '/yellstory/labels/yr3.jpg' },
  { label: 'YR-4 ゴールドxレッド', value: 'yr4', imageUrl: '/yellstory/labels/yr4.jpg' },
  { label: 'YR-5 ブルー(ラメ)xゴールド', value: 'yr5', imageUrl: '/yellstory/labels/yr5.jpg' },
  { label: 'YR-6 エンジ(ラメ)xゴールド', value: 'yr6', imageUrl: '/yellstory/labels/yr6.jpg' },
  { label: 'YR-7 チョコレートxピンク', value: 'yr7', imageUrl: '/yellstory/labels/yr7.jpg' },
  { label: 'YR-8 レッドxピンク', value: 'yr8', imageUrl: '/yellstory/labels/yr8.jpg' },
  { label: 'YR-9 グリーンxシルバー', value: 'yr9', imageUrl: '/yellstory/labels/yr9.jpg' },
  { label: 'YR-10 パープルxホワイト', value: 'yr10', imageUrl: '/yellstory/labels/yr10.jpg' },
  { label: 'YR-11 オールゴールド', value: 'yr11', imageUrl: '/yellstory/labels/yr11.jpg' },
  { label: 'YR-12 シルバーxシルバー', value: 'yr12', imageUrl: '/yellstory/labels/yr12.jpg' },
  { label: 'YR-13 Pスカイブルーxゴールド', value: 'yr13', imageUrl: '/yellstory/labels/yr13.jpg' },
  { label: 'YR-14 Pピンクxゴールド', value: 'yr14', imageUrl: '/yellstory/labels/yr14.jpg' }
]

export const ysrLabelColorObjs = [
  { value: 'yr1', outOfEdge: '#1F201F', edge: '#BEA75C', core: '#BEA75C' },
  { value: 'yr2', outOfEdge: '#1F201F', edge: 'blue', core: '#BEA75C' },
  { value: 'yr3', outOfEdge: '#1F201F', edge: '#fff', core: '#BEA75C' },
  { value: 'yr4', outOfEdge: '#1F201F', edge: 'red', core: '#BEA75C' },
  { value: 'yr5', outOfEdge: '#1F201F', edge: '#BEA75C', core: 'blue' },
  { value: 'yr6', outOfEdge: '#1F201F', edge: '#BEA75C', core: '#B3424A' },
  { value: 'yr7', outOfEdge: '#1F201F', edge: 'pink', core: 'chocolate' },
  { value: 'yr8', outOfEdge: '#1F201F', edge: 'pink', core: 'red' },
  { value: 'yr9', outOfEdge: '#1F201F', edge: 'silver', core: 'green' },
  { value: 'yr10', outOfEdge: '#1F201F', edge: '#fff', core: 'purple' },
  { value: 'yr11', outOfEdge: '#BEA75C', edge: 'gold', core: '#BEA75C' },
  { value: 'yr12', outOfEdge: '#1F201F', edge: 'silver', core: 'silver' },
  { value: 'yr13', outOfEdge: '#1F201F', edge: 'gold', core: 'skyBlue' }, // pSkyblue
  { value: 'yr14', outOfEdge: '#1F201F', edge: 'gold', core: 'pink' } // pPink
]

export const dispatchBestSelectObjects = {
  stitch: stitchObjs,
  linings: leatherOfBestSelectObjs,
  lace: laceObjs,
  hamidashi: hamidashiObjs,
  all: leatherOfBestSelectObjs,
  catchFace: leatherOfBestSelectObjs,
  web: leatherOfBestSelectObjs,
  web2: leatherOfBestSelectObjs,
  edge: defaultColorObjects,
  thumbHook: leatherOfBestSelectObjs,
  littleHook: leatherOfBestSelectObjs,
  indexCover: leatherOfBestSelectObjs,
  thumbOut: leatherOfBestSelectObjs,
  thumbWeb: leatherOfBestSelectObjs,
  indexWeb: leatherOfBestSelectObjs,
  indexMiddle: leatherOfBestSelectObjs,
  middleIndex: leatherOfBestSelectObjs,
  middleRing: leatherOfBestSelectObjs,
  ringMiddle: leatherOfBestSelectObjs,
  ringLittle: leatherOfBestSelectObjs,
  littleRing: leatherOfBestSelectObjs,
  littleOut: leatherOfBestSelectObjs,
  listBelt: leatherOfBestSelectObjs,
  ysrLabel: ysrLabelObjs
}

export const dispatchGoldLineObjects = {
  stitch: stitchObjs,
  linings: leatherOfGoldLineObjs,
  lace: laceObjs,
  hamidashi: hamidashiObjs,
  all: leatherOfGoldLineObjs,
  catchFace: leatherOfGoldLineObjs,
  web: leatherOfGoldLineObjs,
  web2: leatherOfGoldLineObjs,
  edge: defaultColorObjects,
  thumbHook: leatherOfGoldLineObjs,
  littleHook: leatherOfGoldLineObjs,
  indexCover: leatherOfGoldLineObjs,
  thumbOut: leatherOfGoldLineObjs,
  thumbWeb: leatherOfGoldLineObjs,
  indexWeb: leatherOfGoldLineObjs,
  indexMiddle: leatherOfGoldLineObjs,
  middleIndex: leatherOfGoldLineObjs,
  middleRing: leatherOfGoldLineObjs,
  ringMiddle: leatherOfGoldLineObjs,
  ringLittle: leatherOfGoldLineObjs,
  littleRing: leatherOfGoldLineObjs,
  littleOut: leatherOfGoldLineObjs,
  listBelt: leatherOfGoldLineObjs,
  ysrLabel: ysrLabelObjs
}

export const dispatchJuniorLineObjects = {
  stitch: stitchObjs,
  linings: leatherOfJuniorLineObjs,
  lace: laceObjs,
  hamidashi: hamidashiObjs,
  all: leatherOfJuniorLineObjs,
  catchFace: leatherOfJuniorLineObjs,
  web: leatherOfJuniorLineObjs,
  web2: leatherOfJuniorLineObjs,
  edge: defaultColorObjects,
  thumbHook: leatherOfJuniorLineObjs,
  littleHook: leatherOfJuniorLineObjs,
  indexCover: leatherOfJuniorLineObjs,
  thumbOut: leatherOfJuniorLineObjs,
  thumbWeb: leatherOfJuniorLineObjs,
  indexWeb: leatherOfJuniorLineObjs,
  indexMiddle: leatherOfJuniorLineObjs,
  middleIndex: leatherOfJuniorLineObjs,
  middleRing: leatherOfJuniorLineObjs,
  ringMiddle: leatherOfJuniorLineObjs,
  ringLittle: leatherOfJuniorLineObjs,
  littleRing: leatherOfJuniorLineObjs,
  littleOut: leatherOfJuniorLineObjs,
  listBelt: leatherOfJuniorLineObjs,
  ysrLabel: ysrLabelObjs
}

// export const PARTS_BUTTON_OPTION = 'ysr-parts-button-option'
export const LEATHER_COLOR_BUTTON_OPTION = 'ysr-leather-color-button-option'
export const LACE_COLOR_BUTTON_OPTION = 'ysr-lace-color-button-option'
export const EDGE_COLOR_BUTTON_OPTION = 'ysr-edge-color-button-option'
export const STITCH_COLOR_BUTTON_OPTION = 'ysr-stitch-color-button-option'
export const HAMIDASHI_COLOR_BUTTON_OPTION = 'ysr-hamidashi-color-button-option'
export const LABEL_BUTTON_OPTION = 'ysr-label-button-option'
